const CSRF_COOKIE_NAME = 'vattp_csrf';
const CSRF_HEADER_NAME = 'X-CSRF-Token';

function parseCookies(): Record<string, string> {
    const header = document.cookie;
    if (!header) return {};
    return Object.fromEntries(
        header.split(';').map(cookie => {
            const [key, ...v] = cookie.trim().split('=');
            return [key, decodeURIComponent(v.join('='))];
        })
    );
}

export function getCsrfToken(): string | undefined {
    return parseCookies()[CSRF_COOKIE_NAME];
}

export function csrfHeaders(): Record<string, string> {
    const token = getCsrfToken();
    return token ? { [CSRF_HEADER_NAME]: token } : {};
}
